var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 76C63.464 76 76 63.464 76 48C76 32.536 63.464 20 48 20C32.536 20 20 32.536 20 48C20 63.464 32.536 76 48 76ZM48 84C67.8822 84 84 67.8822 84 48C84 28.1177 67.8822 12 48 12C28.1177 12 12 28.1177 12 48C12 67.8822 28.1177 84 48 84ZM52.04 33C52.04 35.2091 50.2492 37 48.04 37H48C45.7909 37 44 35.2091 44 33C44 30.7909 45.7909 29 48 29H48.04C50.2492 29 52.04 30.7909 52.04 33ZM44.04 63C44.04 65.2091 45.8309 67 48.04 67C50.2492 67 52.04 65.2091 52.04 63V47C52.04 44.7909 50.2492 43 48.04 43C45.8309 43 44.04 44.7909 44.04 47V63Z",
    fill: "#0173C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.4a43b0e1.svg";
export { ForwardRef as ReactComponent };